export interface InOrderSkuGroup {
  sku: string;
  packSize: number;
  quantity: number;
}

export interface InOrderCrateSnapshot {
  id: string;
  type: string;
  tagRfid: string;
  skuGroups: InOrderSkuGroup[];
}

export interface InOrderManifestItem {
  sku: string;
  quantity: number;
}

export interface InOrder {
  id: string;
  tenantId: string;
  orderNumber: string;
  issuedAt: number;
  state: string;
  entrySource: string;
  cratesSnapshot: InOrderCrateSnapshot[];
  description: string;
  manifest: InOrderManifestItem[];
}

export enum InOrderState {
  CREATED = 'CREATED',
  RECEIVING = 'RECEIVING',
  FINISHED = 'FINISHED'
}
